import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { VerificationHeadingComponent } from '../verification-heading/verification-heading.component';
import { DrugDetailsComponent } from '../drug-details/drug-details.component';
import { DrugMatchFormComponent } from '../drug-match-form/drug-match-form.component';

@Component({
    selector: 'app-validate-drug-details',
    templateUrl: './validate-drug-details.component.html',
    styleUrls: ['./validate-drug-details.component.scss'],
    imports: [VerificationHeadingComponent, DrugDetailsComponent, DrugMatchFormComponent]
})
export class ValidateDrugDetailsComponent {
  constructor() {}

  @Input() capture: Capture;
  @Input() patientAttachment: PatientAttachment;
}
